import { useEffect } from 'react';

import { LoadingPage } from '@nesso/ui/blocks/loading-page';

import { useVerifyEmailOnMount } from '@/features/users/verify-email';
import { appConfig } from '@/shared/config/app-config';

type Props = {
    token: string;
};

// The confirmation link must work for a signed-out therapist, so it lands here (public) rather
// than on Settings/Profile (session-gated). This page only consumes the token, then hands off to
// the notes app: the Dashboard on success, Settings/Profile for every other outcome since that's
// where the expired modal and the authenticated resend live.
export function VerifyEmailPage({ token }: Props) {
    const status = useVerifyEmailOnMount(token);

    useEffect(() => {
        if (status === 'verifying') return;

        const path = status === 'verified' ? '/dashboard' : '/settings/profile';
        const destination = new URL(path, appConfig.notesAppUrl);
        destination.searchParams.set('emailVerification', status);
        window.location.replace(destination.toString());
    }, [status]);

    return <LoadingPage label="Verifying your email…" />;
}
